<template>
    <div id="app" :style='bg' :class="{'video-bg':$route.name === 'comingSoon'||$route.name === 'video'}">
        <div class="main">
            <router-view></router-view>
        </div>
        <!-- <answer-footer></answer-footer> -->
    </div>
</template>
<script>
import answerFooter from './components/Footer'
var bg = require('./assets/bg.jpg');
var ubg = require('./assets/ubg.jpg');
var welcomebg = require('./assets/welcome.jpg')
export default {
    name: 'App',
    components: { answerFooter },
    computed: {
        bg(){
            if(['Ucenter', 'Mygift'].indexOf(this.$route.name) != -1){
                return {backgroundImage: `url(${ubg})`};
            }else if(['Welcome'].indexOf(this.$route.name) != -1){
                return {backgroundImage: `url(${welcomebg})`};
            }else if(['comingSoon'].indexOf(this.$route.name) != -1||['video'].indexOf(this.$route.name) != -1){
                return {};
            }else{
                return {backgroundImage: `url(${bg})`};
            }
        }
    },
    data(){
        return {
            sty: {color: 'red'}
        }
    },
    created(){
//        this._goCheck();
    },
    methods : {

    }
}

</script>
<style lang="scss">
.video-bg{padding:0 !important}
</style>



// WEBPACK FOOTER //
// src/App.vue